/** Join API base with path segment */
export function apiUrl(base, path) {
  const b = String(base).replace(/\/+$/, '');
  const p = String(path).replace(/^\/+/, '');
  return `${b}/${p}`;
}
